// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__MhV4O","footer":"ModalError_footer__31-91"};